import useDiscard from "../../useDiscard";
import useWeakMap from "../../utils/useWeakMap";


const store = useWeakMap();

const onDiscardProp = props => store.delete(props)

const useMarkParentLinking = (props, parentProps) => {
    if (store.has(props)) {
        return;
    };
    store.set(props, parentProps);
    useDiscard(props, onDiscardProp);
}

export const isContainParentLinking = (props) => store.has(props)

export const getParentLinking = (props) => {
    try {
        return store.get(props);
    } catch (ex) {
        return null;
    }
}

export default useMarkParentLinking